import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import './App.scss';
//import 'antd/dist/antd.css'; 
import 'antd/dist/result.css';

import { connect } from 'react-redux'
import * as actions from './store/actions/auth'

import LoginLayout from './views/containers/LoginLayout'
import Login from './views/containers/Login';
import PortalHome from './views/containers/PortalHome';
import SaccoLayout from './views/containers/Saccoslayout'
import Breadcrumbs from './Breadcrumbs';
//All components
import AccountDetail from './views/containers/AccountDetailView'
import DashBoard from './views/containers/DashBoard';
import CompleteAction from './views/components/CompleteAction';

const App = (props) => {

  const [all_routes, setall_routes] = useState(
    [
      {
        key:1,
        name:"Home",
        Path:"/",
        component:DashBoard

      },
     
      {
        key:3,
        name:"User Details",
        Path:"/useraccounts/:accountID",
        component:AccountDetail
      },

      {
        key:3,
        name:"Cimplete Action",
        Path:"/complete_action/:actionID",
        component:CompleteAction
      },
      
      
    ]

  );


  useEffect(() => {
    props.onTryAutoSignup();

  }, []);


    return (
      props.isAuthenticated ?
      <Router>
        <SaccoLayout {...props}>

       {/* <Breadcrumbs all_routes={all_routes} />*/}

        <Switch>

          {/* Dynamic restaurant routes */}
          {all_routes.map((route, index) => (
            <Route 
              key={index}
              path={route.Path}
              exact // Ensure exact matching
              component={route.component} // Directly use component prop
              >
            
            </Route>
          ))}

        </Switch>

        </SaccoLayout>
      </Router>
      :
      <Router>
      <LoginLayout>

        <PortalHome /> 

      </LoginLayout>
      </Router>
    );
  }


const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null
  }
}

const mapDispatchToProps = dispatch =>{
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(App);
